import { H1, H2, H3, H4, H5, H6 } from '@my/ui'
import { HeadingBlock } from './heading.block'

export const HeadingComponent = (block: HeadingBlock) => {
  const Component = {
    h1: H1,
    h2: H2,
    h3: H3,
    h4: H4,
    h5: H5,
    h6: H6,
  }[block.level]

  return (
    <Component color="$gray13" fow="600" textAlign={block.headingAlignment}>
      {block.heading}
    </Component>
  )
}
